export enum StreamStatus {

  FAILED = 'FAILED',
  PAUSED = 'PAUSED',
  PLAYBACK_PROBLEM = 'PLAYBACK_PROBLEM',
  PLAYING = 'PLAYING',
  PUBLISHING = 'PUBLISHING',
  RESIZE = 'RESIZE',
  SNAPSHOT_COMPLETE = 'SNAPSHOT_COMPLETE',
  STOPPED = 'STOPPED',
  UNPUBLISHING = 'UNPUBLISHING',
  NOT_ENOUGH_BANDWIDTH = 'NOT_ENOUGH_BANDWIDTH',
  UNPUBLISHED = 'UNPUBLISHED'

}
